import { format } from 'date-fns';

import { CARE_ADVERTISEMENT_CARD, CONTENT_CARD_PAGE_PER_COUNT, QUESTION_CARD_COLOR_CLASS, REFUND_ADVERTISEMENT_CARD } from '@/lib/constants/content-section';
import { ContentCardItem, QuestionContent } from '@/lib/types/content';

export const contentPageConverter = (pageNo: number, newContents: QuestionContent[], lastCardItemCount: number, isHideAds?: boolean) => {
  const newCardItems: ContentCardItem[] = [];
  const lastQuestionItemCount = (pageNo - 1) * CONTENT_CARD_PAGE_PER_COUNT;

  for (let index = 0, contentIndex = 0; contentIndex < newContents.length; index++) {
    const currentItemIndex = lastCardItemCount + index;

    if (!isHideAds && currentItemIndex % 5 === 2) {
      const advertisementList = currentItemIndex % 10 === 7 ? REFUND_ADVERTISEMENT_CARD : CARE_ADVERTISEMENT_CARD;
      const advertisementItemIndex = Math.floor(currentItemIndex / 10) % advertisementList.length;

      if (advertisementList[advertisementItemIndex]) newCardItems.push(advertisementList[advertisementItemIndex]);
    } else {
      const item = newContents[contentIndex];
      const colorClass = QUESTION_CARD_COLOR_CLASS[(lastQuestionItemCount + contentIndex) % QUESTION_CARD_COLOR_CLASS.length];

      if (!item || !colorClass) break;
      newCardItems.push({
        id: item.id,
        overText: format(item.createdAt, 'yyyy. M. d.'),
        overTextColorClass: colorClass.overTextColorClass,
        title: item.question,
        titleColorClass: colorClass.titleColorClass,
        backgroundColorClass: colorClass.backgroundColorClass,
        type: 'question',
        respondentOrganization: item.org,
        respondentName: item.name,
        link: `/contents/${item.id}`
      } as ContentCardItem);
      contentIndex++;
    }
  }

  return newCardItems;
};
